export default "__VITE_ASSET__CFYpi2p___"